export default {
	'default.fontFamily':
		"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif",
	'default.fontSize': '13px',

	'helpText.fontSize': '12px',

	mobileTextMinFontSize: '16px',
};
